import { endpoints } from '../endpoints';
import { parseResponse } from '../parseResponse';
import { getHeader } from './generalApi';

export async function getVTDomains(domainNamesList) {
  const nms = domainNamesList.domainNames.join('&domainNames=');
  return fetch(`${endpoints.vtDomain}/domainNames?domainNames=${nms}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}
